import { useCallback, useEffect, useState } from 'react';
import alert from '../../helpers/alert';

const LABELS = {
  mark: {
    add: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð°ÑÐºÑ',
    title: 'ÐÐ¾Ð²Ð°Ñ Ð¼Ð°ÑÐºÐ°',
    fieldLabel: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¼Ð°ÑÐºÐ¸',
    placeholder: 'ÐÐ°Ð¿ÑÐ¸Ð¼ÐµÑ, BYD',
    success: 'ÐÐ°ÑÐºÐ° Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð°',
  },
  model: {
    add: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ',
    title: 'ÐÐ¾Ð²Ð°Ñ Ð¼Ð¾Ð´ÐµÐ»Ñ',
    fieldLabel: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¼Ð¾Ð´ÐµÐ»Ð¸',
    placeholder: 'ÐÐ°Ð¿ÑÐ¸Ð¼ÐµÑ, Song Plus',
    success: 'ÐÐ¾Ð´ÐµÐ»Ñ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð°',
  },
  complectation: {
    add: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ',
    title: 'ÐÐ¾Ð²Ð°Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ',
    fieldLabel: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸',
    placeholder: 'ÐÐ°Ð¿ÑÐ¸Ð¼ÐµÑ, Flagship',
    success: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð°',
  },
};

/**
 * ÐÐ°Ð²ÐµÐ´ÐµÐ½Ð¸Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ° Ð¿ÑÑÐ¼Ð¾ Ð¸Ð· ÑÐµÐ»ÐµÐºÑÐ°: ÐºÐ½Ð¾Ð¿ÐºÐ° Â«ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ...Â» Ð² ÐºÐ¾Ð½ÑÐµ
 * ÑÐ¿Ð¸ÑÐºÐ° Ð¾ÑÐºÑÑÐ²Ð°ÐµÑ Ð¼Ð¾Ð´Ð°Ð»ÐºÑ, ÑÐ¾Ð·Ð´Ð°Ð½Ð½Ð¾Ðµ ÑÑÐ°Ð·Ñ Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÑÐµÑÑÑ Ð² Ð¿Ð¾Ð»Ðµ.
 *
 * Ð¡Ð¾Ð·Ð´Ð°Ð½Ð½Ð¾Ðµ Ð´ÐµÑÐ¶Ð¸Ð¼ Ð² extraOptions: Ð±ÑÐº Ð¾ÑÐ´Ð°ÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿Ð¾ ÑÐ¾ÐºÑÑÑ Ð¸ Ð¾ Ð½Ð¾Ð²Ð¾Ð¹ Ð·Ð°Ð¿Ð¸ÑÐ¸
 * ÐµÑÑ Ð½Ðµ Ð·Ð½Ð°ÐµÑ, Ð° Ð±ÐµÐ· Ð½ÐµÑ Ð² ÑÐ¿Ð¸ÑÐºÐµ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ, Ð¿ÐµÑÐµÐ¾ÑÐºÑÑÐ² ÑÐµÐ»ÐµÐºÑ, Ð·Ð°Ð²ÐµÐ´ÑÑ Ð´ÑÐ±Ð»Ñ.
 *
 * @param {boolean} enabled â Ð²ÐºÐ»ÑÑÐ°ÑÑ Ð»Ð¸ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ðµ (ÑÐ¾Ð»ÑÐºÐ¾ Ð±/Ñ-Ð¿ÑÐ¾ÑÐµÑÑ)
 * @param {'mark'|'model'|'complectation'} kind â ÑÐµÐºÑÑÑ ÐºÐ½Ð¾Ð¿ÐºÐ¸ Ð¸ Ð¼Ð¾Ð´Ð°Ð»ÐºÐ¸
 * @param {Function} create â (name) => Promise<{ value, label }>
 * @param {Function} onChange â Ð²ÑÑÑÐ°Ð²Ð¸ÑÑ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð¿Ð¾Ð»Ñ (field.onChange Ð¸Ð· HookForm)
 * @param {Function} onChangeCustom â Ð¿Ð¾Ð±Ð¾ÑÐ½ÑÐ¹ ÑÑÑÐµÐºÑ ÑÐºÑÐ°Ð½Ð° Ð½Ð° Ð²ÑÐ±Ð¾Ñ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ
 * @param {*} resetKey â Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ ÑÐ±ÑÐ°ÑÑÐ²Ð°ÐµÑ ÑÐ¾Ð·Ð´Ð°Ð½Ð½ÑÐµ Ð¾Ð¿ÑÐ¸Ð¸ (ÑÐ¼ÐµÐ½Ð¸Ð»Ð¸ Ð¼Ð°ÑÐºÑ Ð¸ Ñ.Ð¿.)
 * @param {string} context â ÑÑÐ¾ ÑÐ¶Ðµ Ð²ÑÐ±ÑÐ°Ð½Ð¾, ÑÑÑÐ¾ÐºÐ¾Ð¹ Ð² ÑÐ°Ð¿ÐºÐµ Ð¼Ð¾Ð´Ð°Ð»ÐºÐ¸
 */
const useDictionaryCreator = ({ enabled, kind, create, onChange, onChangeCustom, resetKey, context }) => {
  const [extraOptions, setExtraOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setExtraOptions([]);
  }, [resetKey]);

  const close = useCallback(() => setIsOpen(false), []);

  const submit = useCallback(
    async (input) => {
      const name = (input || '').trim();
      if (!name) return;

      setSaving(true);
      try {
        const option = await create(name);
        setExtraOptions((prev) => [option, ...prev]);
        onChange?.(option);
        onChangeCustom?.(option);
        alert.success(LABELS[kind].success);
        setIsOpen(false);
      } catch (err) {
        alert.error(err?.response?.data?.errorMessage || err?.message || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ');
      } finally {
        setSaving(false);
      }
    },
    [create, kind, onChange, onChangeCustom]
  );

  return {
    extraOptions: enabled ? extraOptions : [],
    // Ð£ÑÐ¾Ð´Ð¸Ñ Ð² selectProps react-select â Ð¾ÑÑÑÐ´Ð° ÐµÐ³Ð¾ ÑÐ¸ÑÐ°ÐµÑ MenuList.
    selectProps: enabled
      ? { isSearchable: true, addOptionLabel: LABELS[kind].add, onAddOption: () => setIsOpen(true) }
      : null,
    modalProps: {
      ...LABELS[kind],
      isOpen: Boolean(enabled && isOpen),
      onClose: close,
      onSubmit: submit,
      saving,
      context,
    },
  };
};

export default useDictionaryCreator;
